export default "__VITE_ASSET__rioxy2RS__"